(() => {
  const breakpoint = 990;
  const rootSelector = '#cloud-search-results.instant-search-menu:not(.cloud-search-results--single-panel):not(.cloud-search-results--mobile)';
  let portal;
  let detail;
  let lastSignature = '';
  let frame = 0;

  const ensurePortal = () => {
    if (portal) return;
    portal = document.createElement('dl');
    portal.className = 'ws-search-detail-portal instant-search-menu';
    portal.setAttribute('aria-live', 'polite');
    detail = document.createElement('dd');
    detail.className = 'active';
    portal.appendChild(detail);
    document.body.appendChild(portal);
  };

  const hide = () => {
    document.body.classList.remove('ws-search-detail-portal-ready');
    if (portal) portal.classList.remove('is-visible');
    lastSignature = '';
  };

  const positionPortal = (root) => {
    const rootRect = root.getBoundingClientRect();
    const gap = 10;
    const edge = 12;
    const preferredWidth = 280;
    const minimumWidth = 220;
    const availableRight = window.innerWidth - edge - rootRect.right - gap;
    const useRight = availableRight >= minimumWidth;
    const width = useRight
      ? Math.min(preferredWidth, availableRight)
      : Math.min(preferredWidth, window.innerWidth - edge * 2);

    portal.style.width = width + 'px';
    portal.classList.add('is-visible');

    const height = Math.min(portal.scrollHeight, 360, window.innerHeight - edge * 2);
    let left = useRight
      ? rootRect.right + gap
      : rootRect.left - gap - width;
    left = Math.max(edge, Math.min(left, window.innerWidth - width - edge));

    const preferredTop = rootRect.top + 10;
    const top = Math.max(edge, Math.min(preferredTop, window.innerHeight - height - edge));

    portal.style.left = Math.round(left) + 'px';
    portal.style.top = Math.round(top) + 'px';
  };

  const sync = () => {
    frame = 0;
    if (window.innerWidth < breakpoint) {
      hide();
      return;
    }

    const root = document.querySelector(rootSelector);
    const active = root && root.querySelector('dd.active');
    if (!root || !active || root.getClientRects().length === 0) {
      hide();
      return;
    }

    ensurePortal();
    const signature = (active.dataset.id || active.dataset.index || '') + '|' + active.innerHTML;
    if (signature !== lastSignature) {
      detail.innerHTML = active.innerHTML;
      detail.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
      detail.querySelectorAll('a').forEach((link) => link.tabIndex = 0);
      detail.scrollTop = 0;
      lastSignature = signature;
    }

    document.body.classList.add('ws-search-detail-portal-ready');
    positionPortal(root);
  };

  const schedule = () => {
    if (!frame) frame = window.requestAnimationFrame(sync);
  };

  const observer = new MutationObserver((records) => {
    const onlyPortalChanges = records.every((record) =>
      portal && (record.target === portal || portal.contains(record.target))
    );
    if (!onlyPortalChanges) schedule();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['class', 'style']
  });

  ['input', 'keydown', 'pointerover', 'focusin', 'scroll'].forEach((eventName) => {
    document.addEventListener(eventName, schedule, true);
  });
  window.addEventListener('resize', schedule, { passive: true });
  schedule();
})();


/* WS clickable search balloon: 2026-10-09 */
(() => {
  const cardSelector = '.ws-search-detail-portal > dd';

  const prepareCard = (card) => {
    const link = card.querySelector('a[href]');
    if (!link) return;
    card.tabIndex = 0;
    card.setAttribute('role', 'link');
    card.setAttribute('aria-label', (link.textContent || 'Bekijk product').trim());
  };

  const prepareVisibleCard = () => {
    const card = document.querySelector(cardSelector);
    if (card) prepareCard(card);
  };

  document.addEventListener('click', (event) => {
    const card = event.target.closest && event.target.closest(cardSelector);
    if (!card || event.target.closest('a[href]')) return;
    const link = card.querySelector('a[href]');
    if (link) window.location.assign(link.href);
  });

  document.addEventListener('keydown', (event) => {
    const card = event.target.closest && event.target.closest(cardSelector);
    if (!card || event.target.closest('a[href]')) return;
    if (event.key !== 'Enter' && event.key !== ' ') return;
    event.preventDefault();
    const link = card.querySelector('a[href]');
    if (link) window.location.assign(link.href);
  });

  new MutationObserver(prepareVisibleCard).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
  prepareVisibleCard();
})();
/* /WS clickable search balloon */
